// import { sbGetOpenChannel } from './openChannel';
import {sbGetGroupChannel} from './groupChannel'
// import SendBird from 'sendbird'
import {parseUrl, getConversationIdFromUrl, isSuperUser} from '../scenes/SendbirdMessenger/util'
import {sanitizeHTML} from 'core/utils/sanitize'

export const sbCreatePreviousMessageListQuery = (channelUrl, isOpenChannel) => {
  return new Promise((resolve, reject) => {
    // if (isOpenChannel) {
    //     sbGetOpenChannel(channelUrl)
    //     .then( (channel) => resolve(channel.createPreviousMessageListQuery()) )
    //     .catch( (error) => reject(error) )
    // } else {
    sbGetGroupChannel(channelUrl)
      .then(channel => resolve(channel.createPreviousMessageListQuery()))
      .catch(error => reject(error))
    // }
  })
}

export const sbGetMessageList = previousMessageListQuery => {
  const limit = 30
  const reverse = true
  return new Promise((resolve, reject) => {
    previousMessageListQuery.load(limit, reverse, (messages, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(messages)
      }
    })
  })
}

export const sbClearChannel = channelUrl => {
  return new Promise((resolve, reject) => {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        channel.resetMyHistory((response, error) => {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
  })
}

export const sbSendTextMessage = (channel, textMessage, callback) => {
  if (channel.isGroupChannel()) {
    channel.endTyping()
  }

  const sanitizedMessage = sanitizeHTML(textMessage)

  return channel.sendUserMessage(sanitizedMessage, (message, error) => {
    callback(message, error)
  })
}

export const sbSendFileMessage = (channel, file, callback) => {
  const data = ''
  const customType = ''
  const thumbSizeList = [{'maxWidth': 160, 'maxHeight': 160}]
  return channel.sendFileMessage(
    file, data, customType, thumbSizeList, e => { callback(e) },
    (message, error) => { callback(message, error) }
  )
}

export const sbTypingStart = channelUrl => {
  return new Promise((resolve, reject) => {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        channel.startTyping()
        resolve(channel)
      })
      .catch(error => reject(error))
  })
}

export const sbTypingEnd = channelUrl => {
  return new Promise((resolve, reject) => {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        channel.endTyping()
        resolve(channel)
      })
      .catch(error => reject(error))
  })
}

export const sbIsTyping = channel => {
  // eslint-disable-next-line no-undef
  if (parseUrl(getConversationIdFromUrl(location.pathname)) === parseUrl(channel.url)) {
    if (channel.isTyping()) {
      const typingMembers = channel.getTypingMembers()
      if (typingMembers.length === 1) {
        return `${typingMembers[0].nickname} is typing...`
      }
      return 'several member are typing...'
    }
    return ''
  }
  return 'otherChat'
}

export const sbMarkAsRead = ({channelUrl, channel}) => {
  // If is super user will not mark messages as read
  if (isSuperUser()) return

  if (channel) {
    // eslint-disable-next-line no-undef
    if (parseUrl(getConversationIdFromUrl(location.pathname)) === parseUrl(channel.url)) {
      channel.markAsRead()
    }
  } else {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        // eslint-disable-next-line no-undef
        if (parseUrl(getConversationIdFromUrl(location.pathname)) === parseUrl(channelUrl)) {
          channel.markAsRead()
        }
      })
  }
}
